<template>
  <div class="Chip">
    <img src="@/assets/Download.png" />
  </div>
</template>

<script>
export default {
  name: 'DownloadedChip',
  props: {
    isMain: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.Chip {
  height: 30px;
  width: 30px;
  border-radius: 15px;
  background-color: white;
  line-height: 24px;
  text-align: center;

  img {
    height: 100%;
    width: 100%;
  }
}
</style>
